// Desktop

const welcomeCell1 = [
  '/images/pages/home/grids/welcome_grid/1_1',
  '/images/pages/home/grids/welcome_grid/1_2',
  '/images/pages/home/grids/welcome_grid/1_3'
];

const welcomeCell2 = [
  '/images/pages/home/grids/welcome_grid/2_1',
  '/images/pages/home/grids/welcome_grid/2_2',
  '/images/pages/home/grids/welcome_grid/2_3'
];

const welcomeCell3 = [
  '/images/pages/home/grids/welcome_grid/3_1',
  '/images/pages/home/grids/welcome_grid/3_2',
  '/images/pages/home/grids/welcome_grid/3_3'
];

const welcomeCell4 = [
  '/images/pages/home/grids/welcome_grid/4_1',
  '/images/pages/home/grids/welcome_grid/4_2',
  '/images/pages/home/grids/welcome_grid/4_3'
];

const welcomeGrid = [welcomeCell1, welcomeCell2, welcomeCell3, welcomeCell4];

const communityCell1 = [
  '/images/pages/home/grids/community_grid/1_1',
  '/images/pages/home/grids/community_grid/1_2',
  '/images/pages/home/grids/community_grid/1_3'
];

const communityCell2 = [
  '/images/pages/home/grids/community_grid/2_1',
  '/images/pages/home/grids/community_grid/2_2',
  '/images/pages/home/grids/community_grid/2_3'
];

const communityCell3 = [
  '/images/pages/home/grids/community_grid/3_1',
  '/images/pages/home/grids/community_grid/3_2',
  '/images/pages/home/grids/community_grid/3_3'
];

const communityCell4 = [
  '/images/pages/home/grids/community_grid/4_1',
  '/images/pages/home/grids/community_grid/4_2',
  '/images/pages/home/grids/community_grid/4_3'
];

const communityGrid = [communityCell1, communityCell2, communityCell3, communityCell4];

const workspacesCell1 = [
  '/images/pages/home/grids/workspaces_grid/conference_room_presentation',
  '/images/pages/home/grids/workspaces_grid/big_globe_light',
  '/images/pages/home/grids/workspaces_grid/four_people_meeting'
];

const workspacesCell2 = [
  '/images/pages/home/grids/workspaces_grid/casual_conference_room',
  '/images/pages/home/grids/workspaces_grid/lounging_area',
  '/images/pages/home/grids/workspaces_grid/work_cafe_chat'
];

const workspacesCell3 = [
  '/images/pages/home/grids/workspaces_grid/clean_kitchen',
  '/images/pages/home/grids/workspaces_grid/person_on_laptop',
  '/images/pages/home/grids/workspaces_grid/wicker_area_conversation'
];

const workspacesCell4 = [
  '/images/pages/home/grids/workspaces_grid/private_office_conversation',
  '/images/pages/home/grids/workspaces_grid/back_to_back_office',
  '/images/pages/home/grids/workspaces_grid/leather_couch_lounge'
];

const workspacesGrid = [workspacesCell1, workspacesCell2, workspacesCell3, workspacesCell4];

// Mobile

const welcomeRotatingImages = [
  '/images/pages/home/grids/welcome_grid/1_1',
  '/images/pages/home/grids/welcome_grid/1_2',
  '/images/pages/home/grids/welcome_grid/1_3'
];

const communityRotatingImages = [
  '/images/pages/home/grids/community_grid/1_1',
  '/images/pages/home/grids/community_grid/1_2',
  '/images/pages/home/grids/community_grid/1_3'
];

const workspacesRotatingImages = [
  '/images/pages/home/section_3/ROWDTLA_retail-brochure_section3_6',
  '/images/pages/home/section_3/ROWDTLA_retail-brochure_section3_7',
  '/images/pages/home/section_3/ROWDTLA_retail-brochure_section3_8'
];

export {
  welcomeGrid,
  communityGrid,
  workspacesGrid,
  welcomeRotatingImages,
  communityRotatingImages,
  workspacesRotatingImages
};
